import React from 'react';
import { CMSContent } from '../components/data/CMSContent';

export const TermsOfUsePage = props => {
  return <CMSContent type={'contentitem'} name={'terms-of-use'} />;
};
